const loginAPI = 'https://mbd.baidu.com/newspage/api/getusername';
const followPOST = 'https://ext.baidu.com/api/subscribe/v2/relation/receive'; // 修改关注状态
const followGET = 'https://ext.baidu.com/api/subscribe/v1/relation/get';// 获取关注状态
const GUIDE_ACTION_API = 'https://ug.baidu.com/mcp/pc/pcsearch';

export {
    loginAPI,
    GUIDE_ACTION_API,
    followPOST,
    followGET,
};